import { render, staticRenderFns } from "./SubsidiaryDetails.vue?vue&type=template&id=b2a509dc&scoped=true"
import script from "./SubsidiaryDetails.vue?vue&type=script&lang=js"
export * from "./SubsidiaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SubsidiaryDetails.vue?vue&type=style&index=0&id=b2a509dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a509dc",
  null
  
)

export default component.exports